export default __webpack_public_path__ + "static/two-917f2c53645f90c15d868aecf1830b11.jpg";